import { Button, HStack, Icon, Text, VStack } from '@betterment/samba-react';

import { SupportCardShimmer } from './LoadingSupportCard';

type Props = { resetError: () => void };

export const ErrorSupportCard = ({ resetError }: Props) => (
  <VStack
    css={{
      gap: 'space.400',
    }}
  >
    <HStack css={{ gap: 'space.50' }}>
      <Icon name="ExclamationCircle" size="small" />
      <Text>
        Something went wrong.{' '}
        <Button
          onClick={e => {
            e.preventDefault();
            resetError();
          }}
          variant="textPrimary"
          aria-label="Refresh page"
        >
          Try again
        </Button>
      </Text>
    </HStack>
    <SupportCardShimmer />
  </VStack>
);
